import { cn } from '@/utils';
import React, { ReactNode } from 'react';

interface PromptInputContainerProps {
  PromptContainer?: React.RefObject<HTMLDivElement>;
  children: ReactNode;
  className?: string;
  lineCount?: number;
}

const PromptInputContainer: React.FC<PromptInputContainerProps> = ({ PromptContainer, children, className = '', lineCount = 1 }) => {
  return (
    <div
      className={cn('prompt_input_box overflow-hidden inline-flex h-24 py-2 px-3 rounded-lg text-white text-lg relative', className)}
      style={{
        boxShadow: `inset 9px 35px 14px rgba(0, 0, 0, 0.03),
                    inset 5px 20px 12px rgba(0, 0, 0, 0.1),
                    inset 2px 9px 9px rgba(0, 0, 0, 0.17),
                    inset 1px 2px 5px rgba(0, 0, 0, 0.2)`,
        background: `linear-gradient(0deg, #191A1B 0%, #1E2021 100%) padding-box, 
                    linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) border-box`,
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        maskImage: lineCount > 3 ? 'linear-gradient(to top, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%)' : 'none',
        marginTop: lineCount > 3 ? '-12px' : '0',
        border: '1px solid transparent',
        borderRadius: 6,
      }}
      ref={PromptContainer}
    >
      {children}
    </div>
  );
};

export default PromptInputContainer;
